import React from "react";
import useModal from "../../../hooks/useModal";
import { sendBackMail } from "../../../services/Api/userService";
import { usePartnerStore } from "../../../stores/admin/users";
import { showToastError, showToastSuccess } from "../../../services/Toasts/toasts";
import pen from "../../../assets/icons/edit.svg";
import send from "../../../assets/icons/send.svg";
import UpdateUserPartner from "../Modales/UpdateUserPartner";
import DeleteUser from "../Modales/DeleteUser";
import trash from "../../../assets/icons/trash.svg";

const PartnerAdminTable = () => {
  // Store
  const { usersPartner } = usePartnerStore();
  // Hook
  const { modalContent, isModalOpen, openModal, closeModal } = useModal();

  const handleSendBack = (idUser: number) => {
    sendBackMail(idUser)
      .then(() => showToastSuccess("L'email a bien été envoyé à l'utilisateur"))
      .catch(() => showToastError("Une erreur s'est produite"));
  };

  return (
    <div className="w-full h-full">
      {isModalOpen ? modalContent : null}
      
      {/* En-têtes de colonnes avec design moderne */}
      <div className="bg-gray-50 border-b border-gray-200 px-6 py-4 sticky top-0">
        <div className="grid grid-cols-7 gap-4 text-sm font-semibold text-gray-700">
          <div className="col-span-1 flex items-center">
            <span className="flex items-center gap-2">
              <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              Nom
            </span>
          </div>
          <div className="col-span-1 flex items-center">
            <span className="flex items-center gap-2">
              <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              Prénom
            </span>
          </div>
          <div className="col-span-2 flex items-center">
            <span className="flex items-center gap-2">
              <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              Email
            </span>
          </div>
          <div className="col-span-1 flex items-center">
            <span className="flex items-center gap-2">
              Titre
            </span>
          </div>
          <div className="col-span-1 flex items-center">
            <span className="flex items-center gap-2">
              <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
              Rôle
            </span>
          </div>
          <div className="col-span-1 flex items-center justify-center">
            <span className="text-center">Actions</span>
          </div>
        </div>
      </div>

      {/* Corps de la table avec design moderne */}
      <div className="w-full overflow-y-auto max-h-[calc(90vh-20rem)]">
        {usersPartner?.length === 0 || usersPartner === undefined ? (
          <div className="text-center py-12">
            <div className="w-16 h-16 mx-auto mb-4 bg-gray-100 rounded-full flex items-center justify-center">
              <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">Aucun collaborateur trouvé</h3>
            <p className="text-gray-500">Aucun utilisateur partenaire n'a été trouvé.</p>
          </div>
        ) : (
          usersPartner?.map((user: any) => (
            <div
              key={user?.id}
              className="w-full hover:bg-blue-50 transition-all duration-200 border-b border-gray-100 grid grid-cols-7 gap-4 px-6 py-4"
            >
              {/* Nom */}
              <div className="col-span-1 flex items-center">
                <div className="font-medium text-gray-900">{user?.lastName}</div>
              </div>
              
              {/* Prénom */}
              <div className="col-span-1 flex items-center">
                <div className="text-gray-700">{user?.firstName}</div>
              </div>
              
              {/* Email */}
              <div className="col-span-2 flex items-center">
                <div className="text-gray-600 text-sm truncate">{user?.eMail}</div>
              </div>
              
              {/* Titre */}
              <div className="col-span-1 flex items-center">
                <div className="text-gray-700">{user?.titre || '-'}</div>
              </div>
              
              {/* Rôle */}
              <div className="col-span-1 flex items-center">
                <div className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                  {user?.role?.role || 'N/A'}
                </div>
              </div>
              
              {/* Actions */}
              <div className="col-span-1 flex items-center justify-center gap-2">
                {/* Bouton Envoyer */}
                <button 
                  onClick={() => handleSendBack(user.id)}
                  className="p-2 bg-green-100 hover:bg-green-200 rounded-lg transition-colors duration-200 cursor-pointer group"
                  title="Envoyer un email"
                >
                  <img 
                    src={send} 
                    alt="icon envoyer" 
                    className="w-4 h-4 group-hover:scale-110 transition-transform duration-200" 
                  />
                </button>
                
                {/* Bouton Modifier */}
                <button
                  type="button"
                  className="p-2 bg-blue-100 hover:bg-blue-200 rounded-lg transition-colors duration-200 cursor-pointer group"
                  onClick={() => {
                    openModal(
                      <UpdateUserPartner
                        id={user?.id}
                        closeModal={closeModal}
                      />
                    );
                  }}
                  title="Modifier"
                >
                  <img 
                    className="w-4 h-4 group-hover:scale-110 transition-transform duration-200" 
                    src={pen} 
                    alt="stylo" 
                  />
                </button>
                
                {/* Bouton Supprimer */}
                <button
                  type="button"
                  className="p-2 bg-red-100 hover:bg-red-200 rounded-lg transition-colors duration-200 cursor-pointer group"
                  onClick={() => {
                    openModal(
                      <DeleteUser idUser={user?.id} closeModal={closeModal} />
                    );
                  }}
                  title="Supprimer"
                >
                  <img 
                    className="w-4 h-4 group-hover:scale-110 transition-transform duration-200" 
                    src={trash} 
                    alt="poubelle" 
                  />
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default React.memo(PartnerAdminTable);
